import React, {useState, useEffect} from 'react';
import '../css/App.css';
import '../css/bootstrap.min.css';
import AlertWindow from '../Alert';
import Permissions from '../Permissions';
import refreshIcon from '../img/refresh.png';
import settingsIcon from '../img/settings.png';
import bootstrap from 'bootstrap';
import Time from '../Time';


class CreateUser extends React.Component {
  constructor(props) {
    super(props);
    this.state = {

      newUserName:"",
      newPassword:"",
      newEmail:"",
      permissions:[],
      alertWindow:"",
      listOfGroups:[]

    };

    this.createUser = this.createUser.bind(this);
    this.openCloseAlert = this.openCloseAlert.bind(this);
    this.addRemovePermission = this.addRemovePermission.bind(this);
    this.handleFormChange = this.handleFormChange.bind(this);
    this.getPermissions = this.getPermissions.bind(this);
  }

  /**
   * Creates a new User
   * 
   */
  createUser = (e) =>{
    e.preventDefault();

    var formdata = new FormData();
    formdata.append("name", this.state.newUserName);
    formdata.append("password", this.state.newPassword);
    formdata.append("email", this.state.newEmail);
    formdata.append("permissions", this.state.permissions.toString());
    
    var requestOptions = {
      method: 'POST',
      body: formdata,
      redirect: 'follow'
    };

    
    fetch("https://dashboard.realsexdoll.info/php/users/createuser.php", requestOptions)
      .then(response => response.text())
      .then(result => this.openCloseAlert())
      .catch(error => console.log('error', error));

  }

  //Open and closes Alerts
  openCloseAlert = () =>{
    let alertStatus = this.state.alertWindow

    if(alertStatus == ""){
      this.setState({alertWindow:<AlertWindow close={this.openCloseAlert} message={"User Created"} />})
    }else{
      this.setState({alertWindow:""})
    }

  }
  
  handleFormChange = (e) =>{
      this.setState({[e.target.id]: e.target.value});
  }

  addRemovePermission = (e) =>{

    let permission = e.target.attributes[1].nodeValue;
    let permissionsList = this.state.permissions;
    
    //Checks if the user already have that permission or not
    if(permissionsList.indexOf(permission) < 0){
      //In this case the user does not have the permission yet so we add it
      permissionsList.push(permission)
      this.setState({permissions:permissionsList})
    }else{
      //In this case we need to make sure to remove the permission from the user
      let index = permissionsList.indexOf(permission)
      permissionsList.splice(index,1)
      this.setState({permissions:permissionsList})
    }

    console.log(permissionsList)

  }

  getPermissions = async() =>{
    let permissionsArray = await Permissions.getAllPermissions();
    this.setState({listOfGroups:permissionsArray})
    console.log(permissionsArray)
    return permissionsArray;
  }

  componentDidMount(){
    this.getPermissions();
    
  }


  render() {

    let listOfGroups;
    if(this.state.listOfGroups.length > 0){
      listOfGroups = this.state.listOfGroups.map((group,i)=>
        <div className='col-4'key={i}>
          <div class="form-check">
            <input onChange={this.addRemovePermission} class="form-check-input" permission={group.groupName} type="checkbox" id={group.groupName}></input>
            <label class="form-check-label" for={group.groupName}>
              {group.groupName}
            </label>
          </div>
        </div>
      )
    }
    
    return(
    <div>
      {this.state.alertWindow}
    <div className='pop-up' onClick={this.props.close}></div>
      <div className="container pop-up-window">
          <div className="row">
            <div>
              <h3>Create User</h3>
            </div>
          </div>
          <div className="row">
            <form onSubmit={this.createUser}>
            <div className='col-12'>
              <div className="mb-3">
                <label for="newUser" className="form-label">User name</label>
                <input type="text" onChange={this.handleFormChange} className="form-control" id="newUserName"></input>
              </div>
              <div className="mb-3">
                <label for="newEmail" className="form-label">Email</label>
                <input type="email" onChange={this.handleFormChange} className="form-control" id="newEmail" placeholder="sex@doll.com"></input>
              </div>
              <div className="mb-3">
                <label for="newPassword" className="form-label">Password</label>
                <input type="password" onChange={this.handleFormChange} className="form-control" id="newPassword" placeholder="Another input placeholder"></input>
              </div>
            </div>
            <div class="row my-3">
              <h4>Permissions</h4>
              {listOfGroups}
              <div className='row mt-3'>
                <div className='col-3'>
                  <button type='submit'>Create user</button>
                </div>
              </div>
            </div>
            </form>
          </div>
      </div>
    </div>
    );
  }
}

export default CreateUser;